import { isMobile } from 'react-device-detect';

import WebcamSharingButton from './WebcamSharing';

import { useConference } from '../../DashboardContent/Dolby';
import { useMytaverseEvent } from '../../../providers';
import { useModal } from '@hooks/modal';
import { useShowInitialMuteModal } from './hooks';

import MicButton from '@core/dashboard/components/HomeBottomBar/MicButton';
import ScreenShareButton from '@core/dashboard/components/HomeBottomBar/ScreenShareButton';
import PersonViewToggleButton from '../PersonViewToggleButton';

const HomeBottomButtonOptions = () => {
  const { ueScreenScreenName } = useConference();

  const {
    currentEvent,
    canSpeak,
    canShowCamera,
    canShareCamera,
    canShareScreen,
  } = useMytaverseEvent();

  const initialMuteModalData = useModal();

  useShowInitialMuteModal({
    eventId: currentEvent?.eventId || '',
    initialMuteModalData,
  });

  return (
    <>
      {canSpeak ? (
        <>
          {canShowCamera || canShareCamera ? <WebcamSharingButton /> : null}

          <MicButton />

          {canShareScreen && !isMobile && ueScreenScreenName ? (
            <ScreenShareButton />
          ) : null}
        </>
      ) : null}

      <PersonViewToggleButton />
    </>
  );
};

export default HomeBottomButtonOptions;
